import React from 'react'
import { Box, Typography } from '@mui/material'

import type { IntegrationFieldsProps } from '../types'

export const DEFAULT_CAYENTA_UTILITY_BILLING_CONFIG = {
  excluded_endpoints: [] as string[],
}

export const CayentaUtilityBillingEditableFields: React.FC<IntegrationFieldsProps> = () => {
  return (
    <Box>
      <Typography variant='body2' sx={{ color: 'text.secondary' }}>
        All protected endpoints require SSN verification before accessing account data.
      </Typography>
    </Box>
  )
}
